import styled from 'styled-components';
import { lg } from '@exonet/react-shared/lib/styled';

export const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  font-size: var(--sm-font-size);

  > div {
    display: contents;

    > strong,
    > span {
      padding: var(--xs-padding-horizontal) 0 var(--xs-padding-vertical) 0;
      vertical-align: top;
      word-break: break-all;
    }

    > strong {
      grid-column: 1;
      font-weight: 600;
      padding-bottom: 0;
    }

    > span {
      grid-column: 1;
      min-width: 0;
      padding-top: 0;
    }
  }

  > div:not(:last-child) > span {
    border-bottom: 1px solid var(--tile-button-bg);
  }

  ${lg(`
    grid-template-columns: max-content minmax(0, 1fr);

    > div {
      > strong,
      > span {
        padding: var(--xs-padding-horizontal) 0 var(--xs-padding-vertical) 0;
      }

      > strong {
        grid-column: 1;
        white-space: nowrap;
        padding-right: 20px;
      }

      > span {
        grid-column: 2;
      }
    }

    > div:not(:last-child) > strong,
    > div:not(:last-child) > span {
      border-bottom: 1px solid var(--tile-button-bg);
    }
  `)}
`;
